import React from "react";
import NewHeader from "../../UiComponent/NewHeader";
import { defaultLabelColors } from "../../utils/constants";
import { useMediaQuery, useTheme } from "@mui/system";
import { useNavigate } from "react-router-dom";
import {
  Add,
  Remove,
} from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CardMedia,
  Grid,
} from "@mui/material";
import iconThree from "../../assets/images/FrankIcons/assureTabImageThree.png";
import iconOne from "../../assets/images/FrankIcons/assureTabImageOne.png";
import iconTwo from "../../assets/images/FrankIcons/assureTabImageTwo.png";
import StepScreen1 from "../../assets/images/tablet_banner.png";
import StepScreen2 from "../../assets/images/tablet_banner2.png";
import StepScreen3 from "../../assets/images/tablet_banner3.png";
import CustomButton from "../../UiComponent/CustomButton";
import {
  handleLocalize,
  useResponsiveValue,
} from "../../utils/helper";
import moment from "moment";
import { HomeIcon, PointerIcon } from "../../assets/images/FrankIcons";
import { SmoothCorners } from "react-smooth-corners";
import { ArrowRightIcon } from "lucide-react";
// import landing_imobile_image from "../../assets/images/landing_imobile_image.png";
import landing_imobile_image2 from "../../assets/images/landing_tablet_image.png";

import { Squircle } from "corner-smoothing";

export default function TabletView(props: any) {
  const { classes } = props;
  const navigate = useNavigate();
  const [state, setState] = React.useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      loadingLoader: false,
      randomProducts: [],
    }
  );

  const handleExpanded = (state_name: any) => {
    try {
      setState({ [state_name]: !state?.[state_name] });
    } catch (error) {}
  };

  const theme = useTheme();
  const screen_1024 = useMediaQuery(theme.breakpoints.up(1025));
  

  return (
    <>
      <div style={{ background: "#FFF8F5" }}>
        <NewHeader />
        <div
          style={{
            padding: "32px 16px",
            background: defaultLabelColors.main_background,
            overflow: "hidden",
          }}
        >
          <div
            style={{
              position: "relative",
            }}
          >
            <SmoothCorners corners="60%" borderRadius={`24px !important`}>
              <div
                style={{
                  position: "relative",
                  zIndex: 2,
                  marginTop: 90,
                  width: "100%",
                  backgroundColor: "#EE6931",
                  
                }}
              >
                <div
                  style={{
                    padding: "32px 20px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      rowGap: 32,
                    }}
                  >
                    <div>
                      <h1
                        className="envoyez-vos-colis"
                        style={{
                          color: defaultLabelColors.white,
                          fontSize: "32px",
                          margin: 0,
                        }}
                      >
                        Envoyez vos colis entre particuliers
                      </h1>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: 20,
                        maxWidth: 782,
                        width: "100%",
                        zIndex:2222,

                      }}
                    >
                      <SmoothCorners
                        corners="60%"
                        width="100%"
                        borderRadius={`32px !important`}
                      >
                        <div
                          className={classes?.banner_tablet_div}
                          style={{
                            background: defaultLabelColors.white,
                            padding: "20px",
                            cursor: "pointer",
                            borderRadius: "32px",
                            // width:"346px"
                          }}
                          onClick={() => {
                            navigate("/send-package");
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ flex: 1 }}>
                              <h3
                                style={{
                                  margin: 0,
                                  fontFamily: "montserrat-Bold",
                                  fontSize: "20px",
                                  color: defaultLabelColors.main_font,
                                }}
                              >
                                Envoyer un colis
                              </h3>
                              <p
                                style={{
                                  fontSize: 14,
                                  color: defaultLabelColors.main_font_grey,
                                  fontFamily: "montserrat-Regular",
                                  marginBottom: 0,
                                }}
                              >
                                Nos transporteurs prennent en charge vos colis
                                 pour un envoi économique.
                              </p>
                            </div>
                            <div
                              style={{
                                background: "#FCE6DD",
                                padding: 12,
                                borderRadius: 100,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <ArrowRightIcon color="#EF6A31" />
                            </div>
                          </div>
                        </div>
                      </SmoothCorners>

                      <SmoothCorners
                        corners="60%"
                        borderRadius={`32px !important`}
                        width="70%"
                      >
                        <div
                          // className={classes?.banner_section_div}
                          className={classes?.banner_tablet_div}
                          style={{
                            background: defaultLabelColors.white,
                            padding: "20px",
                            cursor: "pointer",
                            borderRadius: 32,
                            // width:"346px",

                          }}
                          onClick={() => {
                            navigate("/transporter-un-colis");
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ flex: 1 }}>
                              <h3
                                style={{
                                  margin: 0,
                                  fontFamily: "montserrat-Bold",
                                  fontSize: "20px",
                                  color: defaultLabelColors.main_font,
                                }}
                              >
                                Transporter un colis
                              </h3>
                              <p
                                style={{
                                  fontSize: 14,
                                  color: defaultLabelColors.main_font_grey,
                                  fontFamily: "montserrat-Regular",
                                  marginBottom: 0,
                                }}
                              >
                                Devenez transporteur et gagnez de l'argent{" "}
                                 en assurant des livraisons sur vos
                                trajets.
                              </p>
                            </div>
                            <div
                              style={{
                                background: "#FCE6DD",
                                padding: 12,
                                borderRadius: 100,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <ArrowRightIcon color="#EF6A31" />
                            </div>
                          </div>
                        </div>
                      </SmoothCorners>

                      <p
                        style={{
                          marginLeft: "15%",
                          color: defaultLabelColors.white,
                          fontFamily: "montserrat-Bold",
                          fontSize: 18,
                          margin: 0,
                          marginTop: 12,
                          display:"flex",justifyContent:"center"
                        }}
                        className={classes?.banner_tablet_div}
                      >
                        Je déménage{" "}
                        <span
                          style={{
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            navigate("/transporter-un-colis");
                          }}
                        >
                          C’est par ici !
                        </span>
                      </p>
                    </div>
                  </div>

                  <div
                    style={{
                      position: "absolute",
                      bottom: -20,
                      left: -30,
                      // display:"none"
                    }}
                  >
                    <svg
                      width="879"
                      height="302"
                      viewBox="0 0 879 302"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M368.64 122.285C532.214 170.906 745.469 130.179 836.269 255.808C930.894 386.727 853.978 545.627 737.8 633.045C641.541 705.474 476.877 639.66 334.184 633.597C206.266 628.163 73.6554 674.377 -32.6185 600.313C-148.409 519.617 -182.063 390.422 -175.946 278.079C-169.733 163.968 -126.278 43.167 -0.320768 7.13355C116.407 -26.2596 238.787 83.686 368.64 122.285Z"
                        fill="url(#paint0_linear_1_5603)"
                        fillOpacity="0.2"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_1_5603"
                          x1="444.303"
                          y1="74.9675"
                          x2="210.836"
                          y2="698.705"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#F9E7E0" />
                          <stop offset="1" stopColor="white" stopOpacity="0" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      // display:"none"

                    }}
                  >
                    <svg
                      width="714"
                      height="511"
                      viewBox="0 0 714 511"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M366.546 -116.07C515.247 -199.787 634.301 -381.343 787.72 -359.212C947.601 -336.149 1008.28 -170.368 990.292 -26.0927C975.387 93.4467 813.574 165.99 709.977 264.303C617.106 352.436 558.082 479.863 430.952 504.713C292.438 531.788 176.201 466.116 99.7323 383.587C22.0616 299.759 -34.5148 184.519 27.1962 68.9535C84.3854 -38.1438 248.499 -49.6111 366.546 -116.07Z"
                        fill="url(#paint0_linear_1_5625)"
                        fillOpacity="0.15"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_1_5625"
                          x1="385.17"
                          y1="-203.345"
                          x2="670.971"
                          y2="398.215"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#F9E7E0" />
                          <stop offset="1" stopColor="white" stopOpacity="0" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                </div>
              </div>
            </SmoothCorners>
            <div
              style={{
                position: "absolute",
                // bottom:15,
                // right: 0,
               
              }}
              className={classes?.tab_image_position}
            >
              <img
                className={classes.banner_tab_image} 
                // height={"420px"}
                // style={{height:"350px"}}
                // width={"290px"}
                alt="landing-img"
                src={
                  landing_imobile_image2
                  // "https://static.vecteezy.com/system/resources/thumbnails/027/294/958/small_2x/couple-of-smartphone-14-pro-mockup-screen-on-the-transparent-background-with-shadow-for-your-mobile-ui-ux-png.png"
                }
                
              />
            </div>
          </div>

          <div>
            <Grid
              container
              spacing={3}
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "10px",
                rowGap: 40,
                marginBottom:'30px'
              }}
              className="pour-qui"
            >
              <Grid xs={12} item style={{marginBottom:'30px'}}>
                <h3
                  style={{
                    textAlign: "center",
                    color: "#2D26E6",
                    fontFamily: "montserrat-Bold",
                    fontSize: "32px",
                  }}
                >
                  Pourquoi choisir Frank ?
                </h3>
              </Grid>

              <Grid xs={12} sm={4} item>
                <div
                  style={{
                    position: "relative",
                  }}
                >
                  <SmoothCorners corners="60%" borderRadius={`24px !important`}>
                    <div
                      style={{
                        background: "#F4F3F6",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        height: "248px",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          fontFamily: "montserrat-SemiBold",
                          fontSize: "24px",
                          color: "#2D26E6",
                          textAlign: "center",
                          paddingTop: 50,
                        }}
                        // className="display-flex"
                      >
                        <span style={{ color: "#3026f1", textAlign: "center" }}>
                          Livraison
                        </span>
                        <br />
                        écologique
                        <p
                          style={{
                            fontFamily: "montserrat-SemiBold",
                            fontSize: "16px",
                            color: "#000",
                            padding: "0px 30px 0px 30px",
                          }}
                        >
                          Chaque colis livré par Frank,
                          <br />
                          c'est 25kg de CO2 en moins.
                        </p>
                      </div>
                    </div>
                  </SmoothCorners>

                  <img
                    src={iconOne}
                    style={{
                      position: "absolute",
                      bottom: "55%",
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      left: 0,
                      height: "205px",
                      width:'179px'
                    }}
                    alt="icon-one"
                  />
                </div>
              </Grid>

              <Grid xs={12} sm={4} item>
                <div style={{ position: "relative" }}>
                  <SmoothCorners corners="60%" borderRadius={`24px !important`}>
                    <div
                      style={{
                        background: "#F4F3F6",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        height: "248px",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          fontFamily: "montserrat-SemiBold",
                          fontSize: "24px",
                          color: "#3026f1",
                          textAlign: "center",
                          paddingTop: 50,
                        }}
                      >
                        <span style={{ textAlign: "center" }}>Livraison</span>
                        <br />
                        économique
                        <p
                          style={{
                            fontFamily: "montserrat-SemiBold",
                            fontSize: "16px",
                            color: "#000",
                            padding: "0px 30px 0px 30px",
                          }}
                        >
                          Avec Frank, envoyez vos colis <br /> sans vous ruiner
                          !{" "}
                        </p>
                      </div>
                    </div>
                  </SmoothCorners>
                  <img
                    src={iconTwo}
                    style={{
                      position: "absolute",
                      bottom: "50%",
                      right: 0,
                      height: "198px",
                      width:'174px'
                    }}
                    alt="icon-two"
                  />
                </div>
              </Grid>

              <Grid xs={12} sm={4} item>
                <div style={{ position: "relative" }}>
                  <SmoothCorners corners="60%" borderRadius={`24px !important`}>
                    <div
                      style={{
                        background: "#F4F3F6",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        height: "248px",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          fontFamily: "montserrat-SemiBold",
                          fontSize: "24px",
                          color: "#3026f1",
                          textAlign: "center",
                          paddingTop: "50px",
                        }}
                      >
                        <span style={{ color: "#3026f1", textAlign: "center" }}>
                          Livraison
                        </span>
                        <br />
                        assurée
                        <p
                          style={{
                            fontFamily: "montserrat-SemiBold",
                            fontSize: "16px",
                            color: "#000",
                            padding: "0px 30px 0px 30px",
                          }}
                        >
                          Tous vos colis sont assurés <br /> lors de vos envois
                          !
                        </p>
                      </div>
                    </div>
                  </SmoothCorners>
                  <img
                    src={iconThree}
                    style={{
                      position: "absolute",
                      bottom: "40%",
                      right: "0%",
                      height: "226px",
                      width: "140px",
                      objectFit: "contain",
                      zIndex: 222,
                    }}
                    alt="icon-three"
                  />
                </div>
              </Grid>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-start",
                }}
              >
                <SmoothCorners corners="60%" borderRadius={`12px !important`}>
                  <CustomButton
                    onClick={() => {
                      navigate("/about-us");
                    }}
                    style={{
                      fontFamily: `montserrat-Bold !important`,
                      height: "48px",
                      width: "176px",
                    }}
                    classesNames={"contained_button_tablet"}
                    value={" Nous découvrir"}
                  />
                </SmoothCorners>
              </div>
            </Grid>
          </div>

          <div style={{ marginTop: 30 }}>
            <Grid container spacing={4}>
              <Grid xs={12} item style={{ marginBottom: "30px" }}>
                <h3
                  style={{
                    textAlign: "center",
                    color: "#000",
                    fontFamily: "montserrat-Bold",
                    fontSize: useResponsiveValue("48px", "32px"),
                    marginBottom: 10,
                  }}
                >
                  Les dernières annonces mises en ligne{" "}
                </h3>
                <p
                  style={{
                    fontFamily: "montserrat-Regular",
                    fontSize: 20,
                    color: "#4B4A61",
                    textAlign: "center",
                    margin: 0,
                  }}
                >
                  Transportez les colis de vos voisins !
                </p>
              </Grid>

              {props?.annoucesData?.length > 0 ? (
                props?.annoucesData?.slice(0, 4)?.map((i: any) => {
                  return (
                    <Grid xs={12} item>
                      <div
                        onClick={() => navigate("/transporter-un-colis")}
                        style={{
                          background: defaultLabelColors?.white,
                          padding: 20,
                          borderRadius: 24,
                          cursor: "pointer",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          {i?.shipment_items?.length > 1 ? (
                            <div style={{ width: "80%" }}>
                              <h3
                                style={{
                                  color: "#080626",
                                  fontFamily: "montserrat-Bold",
                                  fontSize: 18,
                                  marginLeft: 1,
                                  display: "-webkit-box",
                                  WebkitLineClamp: 1, // Ensures the text is limited to one line
                                  lineClamp: 1, // Fallback for browsers that support it
                                  WebkitBoxOrient: "vertical",
                                  maxWidth: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  margin: 0,
                                }}
                              >
                                {i?.shipment_items?.length ?? 1} articles :
                                <span
                                  style={{
                                    color: "#78778A",
                                    fontFamily: "montserrat-Regular",
                                    fontSize: 12,
                                    marginLeft: 1,
                                  }}
                                >
                                  {" "}
                                  {i?.shipment_items
                                    ?.map((item: any) => item.item_name_fr)
                                    .join(", ")}
                                </span>
                              </h3>
                            </div>
                          ) : (
                            <h3
                              style={{
                                margin: 0,
                                color: "#080626",
                                fontFamily: "montserrat-Bold",
                                fontSize: 18,
                              }}
                            >
                              {handleLocalize({
                                fr: i?.shipment_items[0]?.item_name_fr,
                                en: i?.shipment_items[0]?.item_name_en,
                              }) ??
                                i?.shipment_items[0]?.prod_name ??
                                ""}{" "}
                            </h3>
                          )}
                          <p
                            style={{
                              margin: 0,
                              color: defaultLabelColors?.main_orange_new,
                              fontSize: 18,
                              fontFamily: "montserrat-Bold",
                            }}
                          >{`${i?.ship_price} €`}</p>
                        </div>
                        <div>
                          <p
                            style={{
                              // margin: 0,
                              // marginBottom: 4,
                              color: "#78778A",
                              fontSize: 12,
                              fontFamily: "montserrat-Regular",
                            }}
                          >
                            {`Publié le ${
                              i?.created_at
                                ? moment(i.created_at).format(
                                    "DD/MM/YYYY à HH[h]mm"
                                  )
                                : ""
                            }`}
                          </p>
                        </div>
                        <div
                          id="detail-div"
                          style={{ display: "flex", gap: 16 }}
                        >
                          <div
                            id="img-div"
                            style={{
                              display: "block",
                              width: "30%",
                            }}
                          >
                            <Grid
                              container
                              spacing={0}
                              sx={{
                                height: "182px",
                                // width: 'calc(100% - 100px)',
                                maxWidth: "244px",
                                // marginRight: "16px",
                                // overflow:"hidden"
                              }}
                            >
                              <Grid
                                item
                                xs={12}
                                key={"_123"}
                                sx={{
                                  position: "relative",
                                  backgroundImage: `url("${encodeURI(
                                    i?.shipment_items?.[0]?.prod_images?.[0]
                                  )}")`,
                                  backgroundRepeat: "no-repeat",
                                  backgroundPosition: "center",
                                  backgroundSize: "cover",
                                  borderRadius: "16px",
                                }}
                              ></Grid>
                            </Grid>
                          </div>

                          <div
                            className="card-details"
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              background: "#F4F3F6",
                              borderRadius: 16,
                              padding: "16px 16px",
                              gap: 10,
                              cursor: "pointer",
                              width: "70%",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-around",
                              }}
                            >
                              <div
                                style={{
                                  width: "36px",
                                  height: "36px",
                                  borderRadius: "50%",
                                  background: "#FFFFFF",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  // boxShadow:
                                  //   "0px 2px 4px rgba(0, 0, 0, 0.1)",
                                }}
                              >
                                <HomeIcon height={30} color="#3026F1" />
                              </div>

                              {/* Dashed Line */}
                              <div
                                style={{
                                  width: "2px",
                                  height: "65px",
                                  borderLeft: "2px dashed #BCBBC4",
                                  margin: "auto",
                                }}
                              />
                              <div
                                style={{
                                  width: "36px",
                                  height: "36px",
                                  borderRadius: "50%",
                                  background: "#FFFFFF",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  // boxShadow:
                                  //   "0px 2px 4px rgba(0, 0, 0, 0.1)",
                                }}
                              >
                                <PointerIcon height={30} color="#F15A24" />
                              </div>
                            </div>
                            <div
                              id="address-div"
                              style={{
                                display: "flex",
                                // gap: 15,
                                justifyContent: "space-between",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              <div
                                id="yess"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div>
                                  <div
                                    style={{
                                      color: "#0000000",
                                      fontSize: 14,
                                      fontFamily: "montserrat-Regular",
                                    }}
                                  >
                                    Adresse de ramassage
                                  </div>
                                  <div
                                    style={{
                                      color: "#0000000",
                                      fontSize: 18,
                                      fontFamily: "montserrat-Medium",
                                    }}
                                  >{`${i?.pickup?.city} , ${i?.pickup?.country}`}</div>
                                </div>
                              </div>
                              <div>
                                <div
                                  style={{
                                    color: "#0000000",
                                    fontSize: 14,
                                    fontFamily: "montserrat-Regular",
                                  }}
                                >
                                  Adresse de livraison
                                </div>
                                <div
                                  style={{
                                    color: "#0000000",
                                    fontSize: 18,
                                    fontFamily: "montserrat-Medium",
                                  }}
                                >
                                  {`${i?.dropoff?.city ?? "city"} , ${
                                    i?.dropoff?.country ?? "country"
                                  }`}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Grid>
                  );
                })
              ) : (
                <div
                  className="frame-2f"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontFamily: "montserrat-Regular",
                    fontSize: "32px",
                    fontWeight: "900",
                    color: "grey",
                    height: "400px",
                  }}
                >
                  Aucune annonce disponible
                </div>
              )}

              <Grid
                xs={12}
                item
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: screen_1024 ? "32px":"20px",
                }}
              >
                <CustomButton
                  style={{}}
                  onClick={() => {
                    navigate("/transporter-un-colis");
                  }}
                  classesNames={"contained_button_two"}
                  value={"Voir toutes les annonces"}
                />
              </Grid>
            </Grid>
          </div>

          <div style={{ marginTop: screen_1024 ? 100 :30 }}>
            <Grid container spacing={2}>
              <Grid xs={12} item>
                <h3
                  style={{
                    textAlign: "center",
                    color: "#000",
                    fontFamily: "montserrat-Bold",
                    fontSize: "32px",
                    marginBottom: 10,
                  }}
                >
                  La livraison de particulier à particulier comment ça marche ?
                </h3>
              </Grid>
            </Grid>
          </div>
        </div>

        <div>
          <Grid
            container
            spacing={0}
            style={{
              background: defaultLabelColors.main_background_new,
              padding: "0px 20px",
              minHeight: 400,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid xs={12} item style={{ placeContent: "center" }}>
              <p
                style={{
                  fontFamily: "montserrat-Bold",
                  color: defaultLabelColors.main_blue,
                  fontSize: 24,
                  margin: 0,
                  textAlign: "center",
                }}
              >
                Vous voulez envoyez un colis ?
              </p>
              <p
                style={{
                  
                  fontFamily: "montserrat-Medium",
                  fontSize: 18,
                  textAlign: "center",
                }}
              >
                Publiez votre annonce en indiquant les détails concernant le
              <br/>
                colis et sa destination.
              </p>
              <span
                style={{
                  fontWeight: "700",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CustomButton
                  style={{
                    background: "transparent",
                    border: "1px solid #BCBBC4",
                    borderRadius: "12px",
                    color: "#080626",
                    // marginTop: "20px",
                    padding: screen_1024 ? "12px 24px":"9px 20px",
                    fontFamily: "montserrat-Bold",
                    fontSize: "16px",
                  }}
                  onClick={() => {
                    navigate("/send-package");
                  }}
                  value={"Envoyer un colis"}
                />
              </span>
            </Grid>
            <Grid xs={12} item>
              <img
                src={StepScreen1}
                alt="step-one"
                style={{
                  height: "440px",
                  width: "100%",
                  objectFit: "contain",
                }}
              />
            </Grid>
          </Grid>

          <Grid
            container
            spacing={0}
            style={{
              background: defaultLabelColors.main_blue,
              // padding: "0px 100px",
            }}
          >
            <Grid
              xs={12}
              item
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                textAlign: "center",
                paddingTop: 32,
              }}
            >
              <p
                style={{
                  fontFamily: "montserrat-Bold",
                  color: defaultLabelColors.white,
                  fontSize: 24,
                  margin: 0,
                  textAlign: "center",
                }}
              >
                Vous vous voyez plutôt transpoteur ?
              </p>
              <p
                style={{
                  margin: 0,
                  fontFamily: "montserrat-Medium",
                  fontSize: 18,
                  textAlign: "center",

                  color: "#fff",
                  marginTop: 10,
                }}
              >
                Parcourez les offres de livraisons disponibles et choisissez
              </p>
              <p
                style={{
                  margin: 0,
                  fontFamily: "montserrat-Medium",
                  fontSize: 18,
                  color: "#fff",
                  textAlign: "center",
                  padding: 0,
                  marginTop: 0,
                }}
              >
                celle qui vous convient.{" "}
              </p>
              <span style={{ fontWeight: "700" }}>
                <CustomButton
                  style={{
                    background: "transparent",
                    border: "1px solid #BCBBC4",
                    borderRadius: "12px",
                    color: "#fff",
                    marginTop: "20px",
                    // padding: "12px 20px",
                    padding: screen_1024 ? "12px 24px":"9px 20px",

                    fontFamily: "montserrat-Bold",
                    fontSize: "16px",
                  }}
                  onClick={() => {
                    navigate("/transporter-un-colis");
                  }}
                  value={"Voir les annonces"}
                />
              </span>
            </Grid>
            <Grid xs={12} item>
              <img
                src={StepScreen2}
                alt="step-one"
                style={{
                top: -100,
                  height: "500px",
                  width: "100%",
                  objectFit: "contain",
                }}
              />
            </Grid>
          </Grid>

          <Grid
            container
            spacing={0}
            style={{ background: defaultLabelColors.main_background_new }}
          >
            <Grid
              xs={12}
              item
              style={{ placeContent: "center", paddingTop: 32 }}
            >
              <p
                style={{
                  fontFamily: "montserrat-Bold",
                  color: defaultLabelColors.main_blue,
                  fontSize: 24,
                  margin: 0,
                  textAlign: "center",
                }}
              >
                Le colis a été livré !
              </p>
              <p
              style={{
                  fontFamily: "montserrat-Medium",
                  fontSize: 18,
                  textAlign: "center",
                }}
              >
                Félicitations ! Votre porte-monnaie 
                <br/>
                se remplit automatiquement une fois que la livraison a été assurée.
              </p>
              <span
                style={{
                  fontWeight: "700",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CustomButton
                  style={{
                    background: "transparent",
                    border: "1px solid #BCBBC4",
                    borderRadius: "12px",
                    color: defaultLabelColors.main_font,
                    // padding: "12px 24px",
                    padding: screen_1024 ? "12px 24px":"9px 20px",

                    fontFamily: "montserrat-Bold",
                    fontSize: "16px",
                  }}
                  onClick={() => {
                    navigate("/wallet");
                  }}
                  value={"Gagner de l’argent"}
                />
              </span>
            </Grid>

            <Grid xs={12} item className="display-flex">
              <img
                src={StepScreen3}
                alt="step-one"
                style={{
                  height: "650px",
                  // width: "100%",
                  objectFit: "contain",
                }}
              />
            </Grid>
          </Grid>

          <div style={{marginBottom:"30px"}}>
            <Grid container spacing={2}>
              <Grid xs={12} item>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 20,
                    flexDirection: "column",
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      fontSize: "32px",
                      fontFamily: "montserrat-Bold",
                      color: "#000",
                      textAlign: "center",
                    }}
                  >
                    Vous êtes un professionnel ?
                  </p>
                  <p
                    style={{
                      fontFamily: "montserrat-SemiBold",
                      fontSize: "24px",
                      color: "#000",
                      margin: 0,
                    }}
                  >
                    Découvrez notre solution <br />
                    de livraison Peoples Post !
                  </p>
                  <p
                    style={{
                      fontFamily: "montserrat-Medium",
                      color: "#000",
                      fontSize: "14px",
                      maxWidth: "480px",
                      textAlign: "center",
                      fontWeight:500
                    }}
                  >
                    Éco-responsable, économique et flexible,la solution Peoples
                    Post change la vie des professionnels.En fonction de vos
                    besoins, nous prenons en charge la collecte,la préparation
                    de commande et même la livraison au client final. Pour plus
                    de fluidité, Peoples Post peut s'intégrer à vos systèmes de
                    gestion via Sendcloud !
                  </p>
                </div>
              </Grid>
            </Grid>
          </div>

          <Squircle
            cornerRadius={16}
            cornerSmoothing={0.6}
            preserveSmoothing
            style={{ padding: 20, background: "#fff" }}
          >
            <Grid
              container
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h2
                  style={{
                    textAlign: "left",
                    fontSize: "22px",
                    padding: "0px 0px 20px 0px",
                    margin: 0,
                    color: "#000",
                  }}
                  className="montserrat-Bold"
                >
                  Nos Actualités
                </h2>
                <ul className="cards">
                  <Grid container spacing={4}>
                    {props?.allBlogs?.slice(0, 3)?.map((item: any) => {
                      return (
                        <>
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            style={{
                              display: "flex",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              navigate(
                                `/blog-details/${item?.blog_cat_id}/${item?.id}`
                              );
                            }}
                          >
                            <div className="card">
                              <CardMedia
                                component="img"
                                style={{
                                  minHeight: 296,
                                  objectFit: "cover",
                                  borderRadius: 8,
                                }}
                                image={
                                  item?.blog_image?.[1] ?? item?.blog_image?.[0]
                                } // Replace with the image URL you need
                                alt="Blog card image"
                              />
                              <div
                                className="card__content"
                                style={{ gap: 10, paddingLeft: 0 }}
                              >
                                <div style={{ display: "flex" }}>
                                  <div
                                    className="card__title"
                                    style={{
                                      flex: 1,
                                      fontSize: "20px",
                                      fontFamily: "montserrat-SemiBold",
                                    }}
                                  >
                                    {handleLocalize(item?.title)}
                                  </div>
                                </div>

                                <p
                                  style={{
                                    fontSize: "16px",
                                    color: "#78778A",
                                    fontWeight: "400",
                                    margin: 0,
                                  }}
                                  className="montserrat-Regular"
                                >
                                  {moment(
                                    `${item?.created_at}`.endsWith("Z")
                                      ? item?.created_at
                                      : item?.created_at + "Z"
                                  ).format("DD MMMM YYYY")}{" "}
                                </p>
                              </div>
                            </div>
                          </Grid>
                        </>
                      );
                    })}
                  </Grid>
                </ul>
              </div>
            </Grid>
          </Squircle>

          <div className="display-flex" style={{marginBottom:'60px',padding:'0px 16px'}}>
            <Grid
              container
              spacing={2}
              marginTop={5}
              style={{
                padding: "0px 16px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid
                xs={12}
                item
                className="display-flex"
                style={{
                  flexDirection: "column",
                  // padding: "10px",
                  borderRadius: "18px",
                }}
              >
                <h3
                  style={{
                    fontSize: "28px",
                    fontFamily: "montserrat-Bold",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    textAlign: "left",
                    width: "100%",
                    padding: "15px",
                    // paddingLeft: "32px",
                    margin: 0,
                    color: defaultLabelColors.main_font_brown,
                  }}
                >
                  FAQ
                </h3>
                <Grid
                  xs={12}
                  item
                  className="display-flex"
                  style={{
                    flexDirection: "column",
                    // padding: "10px",
                    borderRadius: "18px",
                    gap: 20,
                  }}
                >
                  <Accordion
                    elevation={0}
                    style={{
                      border: "0px",
                      background: defaultLabelColors?.main_background_new,
                    }}
                    expanded={state?.expanded_1}
                    onChange={() => handleExpanded("expanded_1")}
                  >
                    <AccordionSummary
                      style={{ border: "none", marginTop: 20 }}
                      // expandIcon={<AddIcon />}
                      expandIcon={
                        state?.expanded_1 ? (
                          <Remove
                            style={{
                              color: defaultLabelColors?.main_orange_new,
                            }}
                          />
                        ) : (
                          <Add />
                        )
                      } // Dynamic icon change
                      className="faq-comments"
                      sx={{
                        "&.Mui-expanded h3": {
                          color: defaultLabelColors?.main_orange_new,
                        }, // Change h3 color when expanded
                      }}
                    >
                      <h3
                        style={{
                          fontWeight: "500",
                          fontFamily: "montserrat-Medium",
                          fontSize: "18px",
                        }}
                      >
                        Comment fonctionne la livraison collaborative ?{" "}
                      </h3>
                    </AccordionSummary>
                    <AccordionDetails
                      style={{
                        width: "90%",
                        fontFamily: "montserrat-Regular",
                        color: "#4B4A61",
                        fontSize: "14px",
                      }}
                    >
                      Grâce à notre plateforme, un particulier peut envoyer un
                      colis qui sera livré par un autre particulier lors d’un de
                      ses trajets personnels. Au cœur de notre activité, la
                      livraison collaborative nous permet de créer une
                      communauté d’entraide en garantissant un service d’envoi
                      peu coûteux et écologique.
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    elevation={0}
                    style={{
                      border: "0px",
                      background: defaultLabelColors?.main_background_new,
                    }}
                    expanded={state?.expanded_2}
                    onChange={() => handleExpanded("expanded_2")}
                  >
                    <AccordionSummary
                      style={{ border: "none", marginTop: 20 }}
                      // expandIcon={<AddIcon />}
                      expandIcon={
                        state?.expanded_2 ? (
                          <Remove
                            style={{
                              color: defaultLabelColors?.main_orange_new,
                            }}
                          />
                        ) : (
                          <Add />
                        )
                      } // Dynamic icon change
                      className="faq-comments"
                      sx={{
                        "&.Mui-expanded h3": {
                          color: defaultLabelColors?.main_orange_new,
                        }, // Change h3 color when expanded
                      }}
                    >
                      <h3
                        style={{
                          fontWeight: "500",
                          fontFamily: "montserrat-Medium",
                          fontSize: "18px",
                          padding: "20px 0px",
                        }}
                      >
                        Comment fonctionne la livraison professionnelle avec
                        Frank ?{" "}
                      </h3>
                    </AccordionSummary>
                    <AccordionDetails
                      style={{
                        width: "90%",
                        fontFamily: "montserrat-Regular",
                        color: "#4B4A61",
                        fontSize: "14px",
                      }}
                    >
                      <p>
                        {" "}
                        Nous couvrons l’envoi du premier au dernier kilomètre et
                        stockons vos colis dans notre entrepôt en Île-de-France.
                        En fonction de vos besoins, nous proposons plusieurs
                        modes de livraison professionnelle :
                      </p>

                      <p>
                        {" "}
                        • Pick & Pack : récupération des colis à votre adresse,
                        préparation des colis, packaging d’envoi{" "}
                      </p>
                      <p>
                        {" "}
                        • Livraison totale : nous nous occupons de tout, de la
                        récupération des colis jusqu’à leur dépôt chez le client
                        final{" "}
                      </p>
                      <p>
                        {" "}
                        • Stockage : nous stockons vos colis dans notre entrepôt
                        en Île-de-France, avant leur retrait
                      </p>

                      <p>
                        Pour plus d’informations, vous pouvez nous contacter en
                        envoyant un mail à l’adresse : hello@frankme.com
                      </p>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion
                    elevation={0}
                    style={{
                      border: "0px",
                      background: defaultLabelColors?.main_background_new,
                    }}
                    expanded={state?.expanded_3}
                    onChange={() => handleExpanded("expanded_3")}
                  >
                    <AccordionSummary
                      style={{ border: "none", marginTop: 20 }}
                      expandIcon={
                        state?.expanded_3 ? (
                          <Remove
                            style={{
                              color: defaultLabelColors?.main_orange_new,
                            }}
                          />
                        ) : (
                          <Add />
                        )
                      }
                      className="faq-comments"
                      sx={{
                        "&.Mui-expanded h3": {
                          color: defaultLabelColors?.main_orange_new,
                        },
                      }}
                    >
                      <h3
                        style={{
                          fontWeight: "500",
                          fontFamily: "montserrat-Medium",
                          fontSize: "18px",
                          padding: "20px 0px",
                        }}
                      >
                        Puis-je gagner de l’argent avec Frank ?
                      </h3>
                    </AccordionSummary>
                    <AccordionDetails
                      style={{
                        width: "90%",
                        fontFamily: "montserrat-Regular",
                        color: "#4B4A61",
                        fontSize: "14px",
                      }}
                    >
                      <p>
                        Vous êtes transporteur ? En voiture, en train, en
                        trottinette, en péniche ou à pied, quel que soit le mode
                        de transport, vous gagnez de l’argent
                        !ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ
                        ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ
                        <br></br>
                        Vous envoyez un colis avec Frank ? Vous ne gagnez pas
                        d’argent, mais vous en économisez à coup sûr !
                      </p>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    elevation={0}
                    style={{
                      border: "0px",
                      background: defaultLabelColors?.main_background_new,
                    }}
                    expanded={state?.expanded_4}
                    onChange={() => handleExpanded("expanded_4")}
                  >
                    <AccordionSummary
                      style={{ border: "none", marginTop: 20 }}
                      // expandIcon={<AddIcon />}
                      expandIcon={
                        state?.expanded_4 ? (
                          <Remove
                            style={{
                              color: defaultLabelColors?.main_orange_new,
                            }}
                          />
                        ) : (
                          <Add />
                        )
                      } // Dynamic icon change
                      className="faq-comments"
                      sx={{
                        "&.Mui-expanded h3": {
                          color: defaultLabelColors?.main_orange_new,
                        }, // Change h3 color when expanded
                      }}
                    >
                      <h3
                        style={{
                          fontWeight: "500",
                          fontFamily: "montserrat-Medium",
                          fontSize: "18px",
                          padding: "20px 0px",
                        }}
                      >
                        Comment fonctionne l’assurance des colis ?{" "}
                      </h3>
                    </AccordionSummary>
                    <AccordionDetails
                      style={{
                        width: "90%",
                        fontFamily: "montserrat-Regular",
                        color: "#4B4A61",
                        fontSize: "14px",
                      }}
                    >
                      Tout envoi de colis via Frank est assuré à une hauteur de
                      100 €. Pour vos colis les plus précieux, vous pouvez
                      souscrire à une assurance supplémentaire
                      (HISCOX).ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ
                    </AccordionDetails>
                  </Accordion>
                  <Accordion
                    elevation={0}
                    style={{
                      border: "0px",
                      background: defaultLabelColors?.main_background_new,
                      width: "100%",
                    }}
                    expanded={state?.expanded_5}
                    onChange={() => handleExpanded("expanded_5")}
                  >
                    <AccordionSummary
                      style={{ border: "none", marginTop: 20 }}
                      // expandIcon={<AddIcon />}
                      expandIcon={
                        state?.expanded_5 ? (
                          <Remove
                            style={{
                              color: defaultLabelColors?.main_orange_new,
                            }}
                          />
                        ) : (
                          <Add />
                        )
                      } // Dynamic icon change
                      className="faq-comments"
                      sx={{
                        "&.Mui-expanded h3": {
                          color: defaultLabelColors?.main_orange_new,
                        }, // Change h3 color when expanded
                      }}
                    >
                      <h3
                        style={{
                          fontWeight: "500",
                          fontFamily: "montserrat-Medium",
                          fontSize: "18px",
                          padding: "20px 0px",
                        }}
                      >
                        Comment devenir transporteur ?
                      </h3>
                    </AccordionSummary>
                    <AccordionDetails
                      style={{
                        width: "100%",
                        fontFamily: "montserrat-Regular",
                        color: "#4B4A61",
                        fontSize: "14px",
                      }}
                    >
                      <p>
                        {" "}
                        Pour devenir transporteur à nos côtés, rien de plus
                        simple :
                        ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ
                        ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ
                      </p>

                      <p>
                        {" "}
                        • Vous créez un compte sur le site ou l’application de
                        Frank ;{" "}
                      </p>
                      <p>
                        {" "}
                        • Vous checkez les annonces à côté de vous, ou sur vos
                        trajets ;{" "}
                      </p>
                      <p> • Vous acceptez une offre ;</p>
                      <p>
                        {" "}
                        • Vous remettez le colis au destinataire, qui vous remet
                        un code pour valider la livraison ;{" "}
                      </p>
                      <p>
                        {" "}
                        • Vous recevez le montant de la livraison sur votre
                        porte-monnaie une fois que vous avez renseigné le code.{" "}
                      </p>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    elevation={0}
                    style={{
                      border: "0px",
                      background: defaultLabelColors?.main_background_new,
                    }}
                    expanded={state?.expanded_6}
                    onChange={() => handleExpanded("expanded_6")}
                  >
                    <AccordionSummary
                      style={{ border: "none", marginTop: 20 }}
                      // expandIcon={<AddIcon />}
                      expandIcon={
                        state?.expanded_6 ? (
                          <Remove
                            style={{
                              color: defaultLabelColors?.main_orange_new,
                            }}
                          />
                        ) : (
                          <Add />
                        )
                      } // Dynamic icon change
                      className="faq-comments"
                      sx={{
                        "&.Mui-expanded h3": {
                          color: defaultLabelColors?.main_orange_new,
                        }, // Change h3 color when expanded
                      }}
                    >
                      <h3
                        style={{
                          fontWeight: "500",
                          fontFamily: "montserrat-Medium",
                          fontSize: "18px",
                          padding: "20px 0px",
                        }}
                      >
                        En tant que transporteur, comment transférer l’argent de
                        mon porte-monnaie sur mon compte bancaire ?{" "}
                      </h3>
                    </AccordionSummary>
                    <AccordionDetails
                      style={{
                        width: "90%",
                        fontFamily: "montserrat-Regular",
                        color: "#4B4A61",
                        fontSize: "14px",
                      }}
                    >
                      Sur l’application Frank, il y a un espace porte-monnaie,
                      où vous trouverez le montant total de vos gains. Il suffit
                      de cliquer sur la carte bancaire, puis sur “transférer sur
                      un compte bancaire” et de renseigner les informations
                      demandées. L’argent arrive sur votre compte au bout de
                      quelques jours !
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    elevation={0}
                    style={{
                      border: "0px",
                      background: defaultLabelColors?.main_background_new,
                    }}
                    expanded={state?.expanded_7}
                    onChange={() => handleExpanded("expanded_7")}
                  >
                    <AccordionSummary
                      style={{ border: "none", marginTop: 20 }}
                      // expandIcon={<AddIcon />}
                      expandIcon={
                        state?.expanded_7 ? (
                          <Remove
                            style={{
                              color: defaultLabelColors?.main_orange_new,
                            }}
                          />
                        ) : (
                          <Add />
                        )
                      } // Dynamic icon change
                      className="faq-comments"
                      sx={{
                        "&.Mui-expanded h3": {
                          color: defaultLabelColors?.main_orange_new,
                        }, // Change h3 color when expanded
                      }}
                    >
                      <h3
                        style={{
                          fontWeight: "500",
                          fontFamily: "montserrat-Medium",
                          fontSize: "18px",
                          padding: "20px 0px",
                        }}
                      >
                        Y a-t-il une limite de poids pour la livraison des colis
                        ?{" "}
                      </h3>
                    </AccordionSummary>
                    <AccordionDetails
                      style={{
                        width: "90%",
                        fontFamily: "montserrat-Regular",
                        color: "#4B4A61",
                        fontSize: "14px",
                      }}
                    >
                      Il n’y a pas de limite de poids chez Frank. Pour un
                      déménagement, vous pouvez prévoir le nombre de personnes
                      dont vous avez besoin en renfort en fonction de la taille
                      des meubles.
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </>
  );
}
